'use client'

import { Image, Text } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { PrivacyCardModel } from '@marketplace-web/user-agreements/privacy-center-data'

const PrivacyAtGlanceCard = ({
  imageSrc,
  title,
  description,
  link,
  link_a11y,
}: PrivacyCardModel) => {
  const translate = useTranslate()

  return (
    <article className="privacy-center__glance-card">
      <div>
        <div className="privacy-center__glance-card-image">
          <Image src={imageSrc} loading="lazy" />
        </div>
        <h3 className="privacy-center__glance-card-title">{translate(title)}</h3>
        <div className="privacy-center__glance-card-description">
          <Text as="p" text={translate(description)} html />
        </div>
      </div>
      <div className="privacy-center__glance-card-link">
        {link && (
          <Text
            as="div"
            text={translate(link)}
            html
            aria={{ 'aria-label': link_a11y ? translate(link_a11y) : '' }}
          />
        )}
      </div>
    </article>
  )
}

export default PrivacyAtGlanceCard
